import { Notyf } from "notyf";
import { router, usePage } from "@inertiajs/vue3";
import "notyf/notyf.min.css";
const page = usePage();

const notyf = new Notyf({
    duration: 3000, // Durasi notifikasi
    position: {
        x: "right",
        y: "top",
    },
    ripple: true,
    dismissible: true,
});

export const notification = () => {
    router.on("finish", () => {
        const message = page.props.message;

        // Pastikan message dan message.body ada
        if (message && message.body) {
            // Hapus semua notifikasi sebelumnya
            notyf.dismissAll();

            // Tampilkan notifikasi berdasarkan jenis pesan
            if (message.type === "success") {
                notyf.success(message.body);
            } else if (message.type === "error") {
                notyf.error(message.body);
            } else {
                notyf.open({ type: "info", message: message.body });
            }

            // Opsional: Hapus pesan setelah ditampilkan agar tidak muncul lagi
            page.props.message = null;
        }
    });
};
